
// Start - Payment Receipt
import {digitsToWords} from './digitsToWords.js'
const getBase64ImageFromURL = async (url)=> {
	return new Promise((resolve, reject) => {
	var img = new Image();
	img.setAttribute("crossOrigin", "anonymous");

	img.onload = () => {
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;

		var ctx = canvas.getContext("2d");
		ctx.drawImage(img, 0, 0);

		var dataURL = canvas.toDataURL("image/png");

		resolve(dataURL);
	};

	img.onerror = error => {
		reject(error);
	};

	img.src = url;
});
}

export const paymentReceiptPDF = async (metaData)=>{
	let pdfDoc =  {
		content: [
			{
				table: {
					widths: ['50%', '50%'],
					body: [
						[
							{
								image: 'sampleImage.jpg',
								width: 100,
								height: 80,
								},
  
								{
								text:
									[
										{ text: 'Firm Name\n', style: 'topFirmAuthority1', },
										{ text: 'Live Address\n', style: 'topFirmHeader',},
										{ text: 'Address\n', style: 'topFirmHeader',},
										{ text: 'GSTIN\n', style: 'topFirmHeader',},
										{ text: 'MOBILE\n', style: 'topFirmHeader',},
										{ text: 'EMAIL\n', style: 'topFirmHeader',},
									]
								},
							],
					],
				
				},
				layout : {
					hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 2 : 0;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 2 : 0;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
					},
				}
			},
				{
				table: {
				    widths: ['100%'],
					body: [
						[
						   {
								text:
									[
										{ text:'CASH RECEIPT\n', style:"borderTitle"}
									]
							},
							
						],
					]
				}
			},
			

			{
				table: {
				    widths: ['100%'],
					body: [
						[
						   {
								text:
									[
										{ text: 'RECEIPT NO                        :       ', bold: true, style:'invoiceDetails' },
										{ text: '123\n', style:'invoiceDetailsBlue' },
										{ text: 'DATE                                     :      ', bold: true, style:'invoiceDetails' },
										{ text: '12/12/12 \n', style:'invoiceDetailsBlue' },
										{ text: 'NAME                                   :      ', bold: true, style:'invoiceDetails' },
										{ text: '1600  \n', style:'invoiceDetailsBlue' },
										{ text: 'ADDRESS                             :      ', bold: true, style:'invoiceDetails' },
										{ text: '7788996655\n', style:'invoiceDetailsBlue' },
										{ text: 'AMOUNT (IN NUMBERS)  :      ', bold: true, style: "invoiceDetails" },
										{ text: '1679905\n', style: "invoiceDetailsBlue" },
										{ text: 'AMOUNT (IN WORDS)       :      ', bold: true, style: "invoiceDetails" },
										{ text: '23\n', style: "invoiceDetailsBlue" },
										{ text: 'PAYMENT TYPE                  :      ', bold: true, style: "invoiceDetails" },
										{ text: '23\n', style: "invoiceDetailsBlue" },
									]
							},
							
						],
					]
				}
			},
	        //{text:'\n'},   
			{
				table: {
					widths: ['30%','40%', '30%'],
					body: [
						[
							{
								   text:
									   [
										   { text: '\n' ,style:''},
										   { text: '' ,style:'invoiceDetails1'},										   
									   ]
							},
							{
								   text:
									   [
										   { text: '\n' ,style:'transpotationDel'},
										   { text: '' ,style:'invoiceDetails1'},
										   
									   ]
							   },
						   
						   {
							   text:
							   [	{ text: '' },
							   { text: 'Firm Name  ', bold: true,	alignment: 'center', style: 'topFirmAuthority' },
							   { text: '\n\n\n\n' },
							   
							   { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'topFirmAuthority'},
							   { text: '\n' },
						   ]
   
						   },
						   ],
					],
				
				},
				layout : {
						hLineWidth: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 2 : 0;
					},
					vLineWidth: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 2 : 0;
					},
					hLineColor: function (i, node) {
						return (i === 0 || i === node.table.body.length) ? 'black' : 'white';
					},
					vLineColor: function (i, node) {
						return (i === 0 || i === node.table.widths.length) ? 'black' : 'white';
					},
				}
			},
			{
				table: {
					widths: ['*'],
					body: [
						[
							{ text: 'Thank you! Stay at home. Be safe. Wear Mask' , style: 'thankyouMsg'},
						],
					],		
				},
			},
		
		],
		styles: {
			header: {
				fontSize: 15,
				bold: true,
				alignment: 'center',
				color: '#160091'
			},
			productHeader: {
				fontSize: 10,
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			transpotationDel : {
				fontSize: 9,
				bold: true,
				alignment: 'center',
				color: '#160091',
			},
			gstHeader: {
				fontSize: 8,
				color: '#160091',
				alignment: 'center'
			},
			gstHeader1: {
				fontSize: 10,
				color: '#160091',
				bold: true,
				alignment: 'center'
			},
			product: {
				fontSize: 9,
				alignment: 'center',
			},
			subproduct: {
				fontSize: 9,
				alignment: 'center',
			},
			product1: {
				fontSize: 7,
				alignment: 'center',
			},
			total: {
				fontSize: 10,
				alignment: 'center',
				bold: true
			},
			total1: {
				fontSize: 7,
				alignment: 'center',
			},
			topHeader: {
				color: '#160091',
				fontSize: 11,
				alignment: 'center',
				bold: true,
			},
			topCustomerHeader: {
				color: '#160091',
				fontSize: 11,
				alignment: 'left',
				bold: true,
			},
			
			topFirmAuthority: {
				color: '#160091',
				fontSize: 9,
				bold: true,
			},
			topFirmAuthority1: {
				color: '#160091',
				fontSize: 12,
				bold: true,
			},
			topFirmHeader: {
				fontSize: 10,
				bold: true,
			},
			invoiceDetails: {
				fontSize: 10,
				bold: true,
			},
			invoiceDetailsBlue: {
				fontSize: 10,
				bold: true,
				color: '#160091'
			},
			invoiceDetailsBlueConsignee: {
				fontSize: 11,
				bold: true,
				color: '#160091'
			},
			invoiceDetails1: {
				fontSize: 9,
				bold: true,
			},
			totalAmountHeader: {
				color: '#160091',
				fontSize: 10,
				bold: true,
			},
			invoiceStatusDetails: {
				color: '#FF0000',
				fontSize: 10,
				bold: true,
			},
			thankyouMsg: {
				color: '#160091',
				fontSize: 12,
				bold: true,
				alignment: 'center',
			},
			borderTitle : {	
			    color: '#160091',
                fontSize: 11,
                alignment: 'center',
                bold: true,
			}
		}
	}
	
		//Firm Details 
		pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
		pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
	
		//Customer and payment details
	
		pdfDoc.content[2].table.body[0][0].text[1].text = "" + "\n";
		pdfDoc.content[2].table.body[0][0].text[3].text = new Date(metaData.payment.date).toLocaleDateString('en-GB').toString() + "\n";
		pdfDoc.content[2].table.body[0][0].text[5].text = (metaData.customer.name ? metaData.customer.name.toUpperCase() : '') + "\n";
		pdfDoc.content[2].table.body[0][0].text[7].text = (metaData.customer.localAddress ? metaData.customer.localAddress.toUpperCase() : '') + "\n";
        pdfDoc.content[2].table.body[0][0].text[9].text = (metaData.payment.amount ? Number.parseFloat(metaData.payment.amount).toFixed(2) : '') + "\n";
        pdfDoc.content[2].table.body[0][0].text[11].text = (metaData.payment.amount ?  _.startCase(digitsToWords(Number.parseFloat(metaData.payment.amount))) : '') + "\n";
        pdfDoc.content[2].table.body[0][0].text[13].text = (metaData.payment.paymentType ? metaData.payment.paymentType.toUpperCase() : '') + "\n";


			
		//authority
	    pdfDoc.content[3].table.body[0][2].text[1].text =  metaData.firm.name ? (metaData.firm.name).toUpperCase() : '';
		
		// Logo 
		if(metaData.terms.printLogo) {
			try {
				let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
				pdfDoc.content[0].table.body[0][0].image = logoData;
				return pdfDoc;
			} catch (error) {
			  console.log(error)
			}
		} else {
			var imgToExport = document.getElementById('pdfimgToExport');
			var canvas = document.createElement('canvas');
			canvas.width = imgToExport.width; 
			canvas.height = imgToExport.height; 
			canvas.getContext('2d').drawImage(imgToExport, 0, 0);
			let base64 = canvas.toDataURL('image/png')
			pdfDoc.content[0].table.body[0][0].image = base64;
		}

		
	return pdfDoc;
}


// WEBPACK FOOTER //
// ./src/utils/PaymentReceipt.js